import Step4CompanyInfo from "../components/CompanySteps/Step4CompanyInfo";
import Step5CompanyAddress from "../components/CompanySteps/Step5CompanyAddress";

export const CompanySteps = [
  {
    component: Step4CompanyInfo,
  },
  {
    component: Step5CompanyAddress,
  },
];
